/***
 * 待辦 API
 * */
import request from '@/api/request'

/** 查詢 待辦 資料 **/
export const requestAllMytodoNoPage = (data) => request({
    url: "/todo",
    method: 'get'
})

/** 分頁查詢 待辦 資料 **/
export const requestAllMytodos = (data) => request({
    url: `/todo/page?pageNum=${data.pageNum}&pageSize=${data.pageSize}&queryField=${data.queryField}&keyword=${data.keyword}`,
    method: 'get'
})

/** 新增/更新 待辦 **/
export const requestSaveMytodo = (data) => request({
    url: '/todo',
    method: 'post',
    data
})

/** 刪除 待辦 **/
export const requestDeleteMytodo = (id) => request({
    url: `/todo/${id}`,
    method: 'delete'
})

/** 查詢可匯出日報清單 **/
export const requestDailyExportItems = (data) => request({
    url: `/report/daily-export-items?startDate=${data.startDate}&endDate=${data.endDate}&empId=${data.empId || ''}&pageNum=${data.pageNum || 1}&pageSize=${data.pageSize || 50}`,
    method: 'get'
})

/** 查詢單筆日報明細 (重用 /job/detail/{id}) **/
export const requestJobDetail = (jobId) => request({
    url: `/job/detail/${jobId}`,
    method: 'get'
})
